import { Define } from "./const_define";
import { Texas } from "../../../net/proto/proto_texasholdem_game";

//牌局数据
export module TableData{
    //当前动作数据
    export interface IActionData{
        min?: number;//最小加注
        max?: number;//最大加注
        callBet?: number;//跟注金额
    }

    //动作失败临时值
    export class TempPlayerData{
        mount:number;//操作的筹码
        state:Define.PlayerState;//玩家状态
    }

    //公共数据
    export class commonData{
        maxBet:number;//本轮最大下注额
        max_join_coin:number;//最大加入
        min_join_coin:number;//最小加入
        sidePotIndex:number;//边池
        isShowHand:boolean;//亮牌
        isNeedAnim:boolean;//是否需要执行动画
        coinStatus:number;//1:锁定玩家金币，2：解锁玩家金币
        isSettle:boolean;//是否在结算状态
        minJoinPeople:number;//最小加入数
        accountbalance:number;//玩家账户余额
    }

    //牌局中座位玩家信息数据
    export class SeatPlayerData{
        //玩家
        playerName:string;
        //服务器座位ID
        player_pos:number;
        //角色ID
        player_id:number;
        //本轮玩家下注额
        bet:number;
        //两张手牌
        cards:number[];
        //玩家余额
        chips:number;
        //账户余额
        balance:number;
        obtainBet:number;//本池获得
        win_lose_bet:number//输赢
        callBet:number;//跟的注额
        betState:number;//下注状态;
        actionIsRight:number;
        cardType:number;//牌型
        //玩家游戏状态
        state:Define.PlayerState;
    }

    //结算中赢家
    export interface IWinnerPlayer{
        id: number;
        bet: number;
        winLoseBet?:number;
        obtainChips?:number;
        feeGold?:number;
        maxCardInfo?:Texas.IMaxCardInfo;
    }

    //玩家在房间的数据
    export interface ISitData{
        playerPos:number;//座位状态，服务器的座位
        state:Define.SitState;
        data?:any;//根据具体状态转换
    }

    //牌局数据
    export class BoardData{
        //房间号
        room_id:number = -1;
        //庄家
        banker:number = -1;
        //公共牌 5 张
        cards:number[] = [];
        //基本押注(底分)
        baseBet:number;
        //大盲注
        bigBlind:number;
        //赌池额
        pot:number;
        //除最后一个边池总额
        sitRole:ISitData[] = [];//坐下或者站起的玩家,
        //游戏状态
        gameState:Define.NextAction;
    }

    //选择自动操作的类型
    export enum AutoSetting{
        None = 0,
        Chek_Pass = 1,//自动过/弃牌
        Any_Call = 2,//跟任何注,
        Auto_Check = 3,//自动过牌
    }

    //自动选牌
    export class Setting{
        isMyRound:boolean;//是否是我方回合
        decision_allowed:number[];//可允许的操作
        autoCheck?:AutoSetting = AutoSetting.None;//自动操作类型
        mount?:number;//跟的数量//当前跟的数量
        actionData?:IActionData;//操作数据
        chips:number;//玩家余额
        isOperator(type:Define.TableSeatAction)
        {
            for (let dec of this.decision_allowed) {
                if (dec == type) {
                    return true;
                }
            }
            return false;
        }

        reset()
        {
            this.isMyRound = false;
            this.autoCheck = AutoSetting.None;
        }
    }


}
